export enum METRICS_TAB {
  ANALYTICS = 'ANALYTICS',
  HIGH_LEVEL = 'HIGH_LEVEL',
}
